/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Ref_N5Inputs */

const en_to_csv_ref_n5 = /** @type {(inputs: To_Csv_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrays get the same treatment. They arrive as a string, not as extra columns.`)
};

const ko_to_csv_ref_n5 = /** @type {(inputs: To_Csv_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`배열도 같은 처리를 받습니다. 추가 열이 아니라 문자열로 도착합니다.`)
};

const ja_to_csv_ref_n5 = /** @type {(inputs: To_Csv_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配列も同じ扱いです。追加の列ではなく文字列として届きます。`)
};

/**
* | output |
* | --- |
* | "Arrays get the same treatment. They arrive as a string, not as extra columns." |
*
* @param {To_Csv_Ref_N5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_ref_n5 = /** @type {((inputs?: To_Csv_Ref_N5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Ref_N5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_ref_n5(inputs)
	if (locale === "ko") return ko_to_csv_ref_n5(inputs)
	return ja_to_csv_ref_n5(inputs)
});